/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import "./AdminDSR.css";
import { FiEdit2, FiTrash2, FiPlus } from "react-icons/fi";
import { AiOutlineEye, AiOutlineDownload, AiOutlineClose } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const HomeTab = ({
  // search & filter
  searchTerm,
  setSearchTerm,
  selectFilter,
  setSelectFilter,
  displayData,

  // notes modal
  showNotesModal,
  setShowNotesModal,
  notesUrl,
  handleViewNotes,
  handleDownloadNotes,

  // docs modal
  showDocsModal,
  setShowDocsModal,
  docsList,
  handleViewDocs,
  handleDownloadAllDocuments,
  handlePreviewSingleDoc,
  handleDownloadSingleDoc,
  getValidDocs,
  hasValidNotes,

  // add/edit project modal
  showModal,
  modalType,
  closeModal,
  formData,
  setFormData,
  projectTypes,
  employees,
  loadingEditData,
  handleFormSubmit,
  handleUserCheckboxChange,
  getSelectedUserNames,
  getAllSelectedUserNames,
  userDropdownRef,
  hasValidDocs,
  getDocPath,
  FILE_PREFIX,
  downloadFile,

  // delete modal
  showDeleteModal,
  setShowDeleteModal,
  deleteId,
  setDeleteId,
  deleteProjectName,
  setDeleteProjectName,
  setModalType,
  handleDeleteConfirm,
  handleDeleteCancel,

  // open modal
  openModal,
}) => {
  return (
    <>
      <div className="inner-body-container-of-employee-AdminDSR row-12">
        <div className="first-side-in-body-AdminDSR">
          <select
            value={selectFilter}
            onChange={(e) => setSelectFilter(e.target.value)}
            className="select-dropdown-AdminDSR"
          >
            <option value="name">Name</option>
            <option value="type">Project Type</option>
            <option value="assignedUser">Assigned User</option>
          </select>

          <div className="input-for-search-in-employee-AdminDSR">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <button
            className="add-button-AdminDSR"
            onClick={() => openModal("addProject")}
          >
            <FiPlus /> Add Project
          </button>
        </div>
      </div>

      <div className="table-in-all-emplyee-AdminDSR">
        <table className="table-main-AdminDSR">
          <thead className="thead-main-AdminDSR">
            <tr>
              <th>Name</th>
              <th>Project Type</th>
              <th>Assigned User</th>
              <th>Project Notes</th>
              <th>Project Documents</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody className="tbody-main-AdminDSR">
            {displayData.length > 0 ? (
              displayData.map((item) => {
                const notesFileUrl = item.projectNotesFile;
                const docsArr = item.projectDocuments;
                const validDocs = getValidDocs(docsArr);

                return (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.type}</td>
                    <td>{item.assignedUserName}</td>

                    <td>
                      {hasValidNotes(notesFileUrl) ? (
                        <div className="project-file-actions-AdminDSR">
                          <button
                            className="icon-btn-AdminDSR"
                            title="View Notes"
                            onClick={() => handleViewNotes(notesFileUrl)}
                          >
                            <AiOutlineEye />
                          </button>

                          <button
                            className="icon-btn-AdminDSR"
                            title="Download Notes"
                            onClick={() => handleDownloadNotes(notesFileUrl)}
                          >
                            <AiOutlineDownload />
                          </button>
                        </div>
                      ) : null}
                    </td>

                    <td>
                      {validDocs.length > 0 ? (
                        <div className="project-file-actions-AdminDSR">
                          <button
                            className="icon-btn-AdminDSR"
                            title="View Documents"
                            onClick={() => handleViewDocs(validDocs)}
                          >
                            <AiOutlineEye />
                          </button>

                          <button
                            className="icon-btn-AdminDSR"
                            title="Download All Documents"
                            onClick={() =>
                              handleDownloadAllDocuments(validDocs)
                            }
                          >
                            <AiOutlineDownload />
                          </button>
                        </div>
                      ) : null}
                    </td>

                    <td>
                      <div className="project-action-buttons-AdminDSR">
                        <button
                          className="icon-btn-AdminDSR"
                          title="Edit Project"
                          onClick={() => openModal("addProject", item)}
                        >
                          <FiEdit2 />
                        </button>

                        <button
                          className="icon-btn-AdminDSR delete-project-icon-AdminDSR"
                          title="Delete Project"
                          onClick={() => {
                            setDeleteId(item.id);
                            setDeleteProjectName(item.name || "");
                            setShowDeleteModal(true);
                            setModalType("deleteProject");
                          }}
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6">No record found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        show={showNotesModal}
        onHide={() => setShowNotesModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Project Notes</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {notesUrl ? (
            <iframe
              src={notesUrl}
              title="Project Notes"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          ) : (
            <div>No notes available.</div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDocsModal}
        onHide={() => setShowDocsModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Project Documents</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {docsList.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th style={{ width: "120px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {docsList.map((doc, index) => (
                  <tr key={index}>
                    <td>{doc.fileName}</td>
                    <td>
                      <button
                        className="icon-btn-AdminDSR"
                        title="Preview"
                        style={{ marginRight: 8 }}
                        onClick={() => handlePreviewSingleDoc(doc.url)}
                      >
                        <AiOutlineEye />
                      </button>

                      <button
                        className="icon-btn-AdminDSR"
                        title="Download"
                        onClick={() =>
                          handleDownloadSingleDoc(doc.url, doc.fileName)
                        }
                      >
                        <AiOutlineDownload />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No documents available</div>
          )}
        </Modal.Body>
      </Modal>

      {showModal && modalType === "addProject" && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Project Information</h3>
              <button onClick={closeModal} className="close-button-AdminDSR">
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <div className="form-group-AdminDSR">
                <label>Project Name: *</label>
                <input
                  type="text"
                  placeholder="Enter Project Name"
                  value={formData.ProjectName || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, ProjectName: e.target.value })
                  }
                />
              </div>

              <div className="form-group-AdminDSR">
                <label>Project Type: *</label>
                <select
                  value={formData.ProjectType || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, ProjectType: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  {projectTypes.map((type) => (
                    <option key={type.Id} value={type.Id}>
                      {type.ProjectType1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group-AdminDSR" ref={userDropdownRef}>
                <label>Assign User: *</label>

                <div className="multi-select-dropdown-AdminDSR">
                  <div
                    className="multi-select-header-AdminDSR"
                    title={getAllSelectedUserNames()}
                    onClick={() =>
                      setFormData({
                        ...formData,
                        showUserDropdown: !formData.showUserDropdown,
                      })
                    }
                  >
                    <span className="multi-select-header-text-AdminDSR">
                      {getSelectedUserNames()}
                    </span>
                    <span className="multi-select-arrow-AdminDSR">
                      {formData.showUserDropdown ? "▲" : "▼"}
                    </span>
                  </div>

                  {formData.showUserDropdown && (
                    <div className="multi-select-list-AdminDSR">
                      {employees.length > 0 ? (
                        employees.map((emp) => (
                          <label
                            key={emp.id}
                            className="multi-select-item-AdminDSR"
                          >
                            <input
                              type="checkbox"
                              checked={(formData.AssignedUserIds || []).includes(
                                String(emp.id)
                              )}
                              onChange={() => handleUserCheckboxChange(emp.id)}
                            />
                            <span>{emp.name}</span>
                          </label>
                        ))
                      ) : (
                        <div className="multi-select-empty-AdminDSR">
                          No users found
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group-AdminDSR">
                <label>Project Notes: *</label>

                {hasValidNotes(formData.ExistingProjectNotesFile) && (
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Existing Notes:</strong>
                    <div>
                      <button
                        type="button"
                        onClick={() =>
                          handleViewNotes(formData.ExistingProjectNotesFile)
                        }
                        className="icon-btn-AdminDSR"
                        style={{ marginRight: 8 }}
                      >
                        View
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          handleDownloadNotes(formData.ExistingProjectNotesFile)
                        }
                        className="icon-btn-AdminDSR"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                )}

                {loadingEditData ? (
                  <div style={{ padding: "20px 0" }}>Loading notes...</div>
                ) : (
                  <ReactQuill
                    theme="snow"
                    value={formData.ProjectNoteHtmlContent || ""}
                    onChange={(value) =>
                      setFormData({
                        ...formData,
                        ProjectNoteHtmlContent: value,
                      })
                    }
                    style={{ height: "200px", marginBottom: "40px" }}
                  />
                )}
              </div>

              <div className="form-group-AdminDSR">
                <label>Project Documents (Multiple Files):
                  
                </label>

                {hasValidDocs(formData.ExistingProjectDocuments) && (
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Existing Documents:</strong>

                    {getValidDocs(formData.ExistingProjectDocuments).map(
                      (doc, index) => {
                        const docPath = getDocPath(doc);
                        const fullUrl = docPath.startsWith("http")
                          ? docPath
                          : FILE_PREFIX + docPath;

                        const fileName = docPath
                          .split("\\")
                          .pop()
                          .split("/")
                          .pop();

                        return (
                          <div key={index} style={{ marginBottom: "8px" }}>
                            <span>{fileName}</span>

                            <button
                              type="button"
                              style={{ marginLeft: 10, marginRight: 5 }}
                              onClick={() => window.open(fullUrl, "_blank")}
                            >
                              View
                            </button>

                            <button
                              type="button"
                              onClick={() => downloadFile(fullUrl, fileName)}
                            >
                              Download
                            </button>
                          </div>
                        );
                      }
                    )}
                  </div>
                )}

                <input
                  type="file"
                  multiple
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      ProjectDocumentsFiles: Array.from(e.target.files || []),
                    })
                  }
                />
              </div>
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleFormSubmit}
              >
                Save
              </button>
              <button className="cancel-button-AdminDSR" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-delete-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Confirm Delete</h3>
              <button
                onClick={handleDeleteCancel}
                className="close-button-AdminDSR"
              >
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <p className="delete-confirm-text-AdminDSR">
                Are you sure you want to delete this record?
              </p>

              {modalType === "deleteProject" && deleteProjectName && (
                <div className="delete-project-name-box-AdminDSR">
                  <span>Project Name</span>
                  <strong>{deleteProjectName}</strong>
                </div>
              )}
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleDeleteConfirm}
                style={{ backgroundColor: "#dc3545" }}
              >
                Yes, Delete
              </button>

              <button
                className="cancel-button-AdminDSR"
                onClick={handleDeleteCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeTab;
